import React from 'react';
import { getTranslateByScope } from '../../i18n';
import { OUTDOOR_CLUSTER } from '../../constants';
import { Clusters } from './Clusters';

const translate = getTranslateByScope('app.clusters.outdoorClusters');

export const OutdoorClusters = (props) => (
  <Clusters
    title={translate('title')}
    clusterType={OUTDOOR_CLUSTER}
    {...props}
  />
);
